import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: { 
		auth : {
			isChecked : false,
			isSigned : false,
			type : "",
			isUser : false,
			isAdmin : false,
			client : {}
		},
		menu : {
			show : true,
			items : []
		}
	},
	getters:{ 
		getAuth(state){
			return state.auth
		},
		getMenu(state){
			return state.menu
		},
	},
    mutations: { 
		m_authCheckSigned(state,data){
			if(data.success){
				state.auth.isSigned = true;
				state.auth.type = data.auth_type;
				state.auth.client = data.client;
				state.auth.isAdmin = data.auth_type == "admin";
				state.auth.isUser = data.auth_type == "user";

				state.menu.items = data.menu || [];
			}else{
				state.auth.isSigned = false;
			}
			state.auth.isChecked = true;
		},


		m_menuShowToggle(state){
			state.menu.show = !state.menu.show
		}, 
	},
    actions: {
		a_authCheckSigned(context){
			Vue.http.get( process.env.VUE_APP_API_URL + "/auth/check" ).then(response => { 
				context.commit("m_authCheckSigned",response.body)
			}) 
		}, 


		a_menuShowToggle(context){
			context.commit("m_menuShowToggle")
		}
	},
    modules: {}
})